import {Component} from 'react';
import PropTypes from 'prop-types';

class ValueResolver extends Component {
    render() {
        if(this.props.propertyDefinition && this.props.propertyDefinition.type) {
            switch (this.props.propertyDefinition.type) {
                case 'AppBundle\\Form\\Type\\ValueSelectType':
                    let valueId = Object.keys(this.props.propertyDefinition.possibleValues).filter(function (key) {
                        let vd = this.props.propertyDefinition.possibleValues[key];
                        return vd[this.props.searchAttribute] === this.props.value
                    }.bind(this))[0];
                    return this.props.propertyDefinition.possibleValues[valueId][this.props.resolveAttribute];

                default:
                    return this.props.value
            }
        }
        else return this.props.value;
    }
}

ValueResolver.propTypes = {
    propertyDefinition: PropTypes.object.isRequired,
    searchAttribute: PropTypes.string.isRequired,
    resolveAttribute: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default ValueResolver



// WEBPACK FOOTER //
// ./src/components/reusables/ValueResolver.js